<template>
  <div>
    <div class="row">
      <div class="col-md-12 mmtopone">
        <!-- <div class="input-group mb-3 peditboxes">
                <input type="text" class="form-control searchbox" :placeholder="$t('find_job')" aria-label="Recipient's username" aria-describedby="basic-addon2">
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary" type="button">
                    <i class="fa fa-search" aria-hidden="true"></i>
                    </button>
                </div>
        </div> -->
        <div class="mmenu_item" :selectedItem="selectedItem==1" @click="goToPage(1)">
          <span class="mmenu_item_txt mplus2p-m spacing1-2">{{$t('ep_page')}}</span>
          <span class="mmenu_item_arrow mplus2p-m spacing1-2">
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </span>
        </div>
        <div v-if="!testUser && interview_completion"  class="mmenu_item" :selectedItem="selectedItem==44" @click="goToPage(44)">
          <span class="mmenu_item_txt mplus2p-m spacing1-2">{{$t('message')}}</span>
          <span class="mmenu_item_arrow mplus2p-m spacing1-2">
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </span>
          <span class="mmenu_item_badge mplus2p-m spacing1-2">
            <span class="mbadge_num" >{{notificationCount}}</span> {{$t('page_item')}}
          </span>
        </div>
      </div>
      <div v-if="window_width <= (768-17)" class="col-md-12">
        <div class="mmenu_item" id="more_option" @click="clicked_moreoption()">
          <span class="mmenu_item_txt mplus2p-m spacing1-2">View Option</span>
          <span class="mmenu_item_arrow mplus2p-m spacing1-2">
            <i class="fa fa-angle-down" aria-hidden="true"></i>
          </span>
        </div>
      </div>

      <div v-if="role != 'engineer'" class="col-md-12 options">
        <p class="mmenu_headers mplus2p-m spacing1-2 noiseblack">{{$t('personnel_list')}}</p>
        <div class="mmenu_item" :selectedItem="selectedItem==51" @click="goToPage(51)">
          <span class="mmenu_item_txt mplus2p-m spacing1-2">{{$t('engineer_list')}}</span>
          <span class="mmenu_item_arrow mplus2p-m spacing1-2">
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </span>
        </div>
        <div class="mmenu_item" :selectedItem="selectedItem==52" @click="goToPage(52)">
          <span class="mmenu_item_txt mplus2p-m spacing1-2">{{$t('asked_price_person_who_was')}}</span>
          <span class="mmenu_item_arrow mplus2p-m spacing1-2">
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </span>
        </div>
      </div>
      <div class="col-md-12 options">

        <p class="mmenu_headers mplus2p-m spacing1-2 noiseblack">{{$t('ep_other_sidebar')}}</p>
          <div class="mmenu_item" :selectedItem="selectedItem==61" @click="goToPage(61)">
            <span class="mmenu_item_txt mplus2p-m spacing1-2">{{$t('ep_button')}}</span>
            <span class="mmenu_item_arrow mplus2p-m spacing1-2">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </div>

          <div class="mmenu_item" :selectedItem="selectedItem==62" @click="goToPage(62)">
            <span class="mmenu_item_txt mplus2p-m spacing1-2">{{$t('sk_skill_update')}}</span>
            <span class="mmenu_item_arrow mplus2p-m spacing1-2">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </div>
          <div  class="mmenu_item" :selectedItem="selectedItem==63" @click="goToPage(63)">
            <span class="mmenu_item_txt mplus2p-m spacing1-2">{{$t('resume_UP')}}</span>
            <span class="mmenu_item_arrow mplus2p-m spacing1-2">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </div>

          <div class="mmenu_item" :selectedItem="selectedItem==64" @click="goToPage(64)">
            <span class="mmenu_item_txt mplus2p-m spacing1-2">{{$t('setting_menu_name')}}</span>
            <span class="mmenu_item_arrow mplus2p-m spacing1-2">
              <i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
          </div>
      </div>
      <div class="col-md-12 options">
        <p class="mmenu_headers mplus2p-m spacing1-2 noiseblack">{{$t('option')}}</p>
         <div class="mmenu_item" :selectedItem="selectedItem==91" @click="goToPage(91)">
          <span class="mmenu_item_txt mplus2p-m spacing1-2">{{$t('usage_guide')}}</span>
          <span class="mmenu_item_arrow mplus2p-m spacing1-2">
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import router from "vue-router";
import {EventBus} from "../../main.js";
export default {
  data() {
    return {
      ENV: '',
      window_width: "",
      selectedItem: "",
      role: "",
      userId: "",
      testUser: 0,
      unAnswereCount: "",
      notificationCount: "",
      replayCount: "",
      interview_completion: false
    };
  },
  mounted() {
    if (this.role == "engineer") {
      var retrievedData = localStorage.getItem("user");
      var data = JSON.parse(retrievedData);
      this.testUser = data.test_user;
      this.userId = data.user_token;
    }
    this.getNotificationCount();
    this.ENV = process.env.NODE_ENV;
    this.window_width = $(window).width() + 17;
    this.showorhide();
    this.getInterviewCompleted();
  },
  created() {
    this.role = localStorage.getItem("role");
  },
  computed: {
    onResize(event) {
      this.window_width = $(window).width() + 17;
      this.showorhide();
    },


  },
  methods: {
    getNotificationCount() {
        axios
          .get("unread/notification/count?token=" + localStorage.getItem("token"), {
            headers: {"X-localization": localStorage.getItem("lan")}
          })
          .then(res => {
            this.notificationCount = res.data.message_count;
          })
          .catch(error => {
          });
        this.$forceUpdate();
      },
      getInterviewCompleted(){
        axios
          .get("interview-completion-flag?token=" + localStorage.getItem("token"), {
            headers: {"X-localization": localStorage.getItem("lan")}
          })
          .then(res => {
            this.interview_completion = res.data.interview_completed;
          })
          .catch(error => {
          });
      },
    goToPage(pageId) {
      var itemId = this.$route.params.cid;
      var u_id = this.$route.params.uid;

      switch (pageId) {
        case 1:
          this.$router.push("/engineer/profile/" + this.userId);
          break;

        case 2:
          this.$router.push({
            name: "engineerUnanswered",
            params: { uid: this.userId },
            query: { page: 1 }
          });
          break;

        case 3:
          this.$router.push({
            name: "engineerReplay",
            params: { uid: this.userId },
            query: { page: 1 }
          });
          break;

        case 40:
          this.$router.push({
            name: "engineerCompanyList",
            query: { page: 1 }
          });
          break;
        case 41:
          this.$router.push({
            name: "engineerFavoritedByCompany",
            params: { uid: this.userId },
            query: { page: 1 }
          });
          break;
        case 42:
          this.$router.push({
            name: "favoritedCompany",
            params: { uid: this.userId },
            query: { page: 1 }
          });
          break;
        case 43:
          this.$router.push({
            name: "favoritedRecruit",
            params: { uid: this.userId },
            query: { page: 1 }
          });
          break;
        case 44:
          this.$router.push("/engineer/chataction-list");
          break;

        case 45:
        this.$router.push({
          name: "engineerRecruitList",
          query: { page: 1 }
        });
        break;

        case 61:
          this.$router.push({
            name: "engineerProfileEdit",
            params: { uid: this.userId },
            query: { page: 1 }
          });
          break;
        case 62:
          this.$router.push("/engineer/skill-update");
          break;
        case 63:
          this.$router.push({name: 'ResumeUP'});
          break;
        case 64:
          this.$router.push({name: 'EngineerSettingMail'});
          break;

        case 91:
          this.$router.push({name: "EngineerUsageGuide"});
          break;

        default:
          break;
      }
    },
    showorhide() {
      if (this.window_width > 768) {
        $(".options").removeClass("hider");
        $(".options").addClass("show");
      }
      if (this.window_width <= 768) {
        $(".options").removeClass("show");
        $(".options").addClass("hider");
      }
    },
    clicked_moreoption() {
      if ($(".options").hasClass("hider")) {
        $(".options").removeClass("hider");
        $(".options").addClass("show");
      } else {
        $(".options").removeClass("show");
        $(".options").addClass("hider");
      }
    }
  }
};
</script>

<style scoped>
.companyad {
  width: 100%;
}

.leftad {
  padding: 70px 20px;
}

.rightad {
  text-align: center;
  padding: 30px 0px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  max-width: 200px;
  height: 100px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  margin-bottom: 0.1rem;
}

.statusnum {
  position: absolute;
  /*right: 46%;
      top: 55%;*/
  font-weight: bold;
  font-size: 1.5rem;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.searchbox {
  height: 40px;
  border-radius: 4px;
  background-color: #f0f2f4;
  border: 1px solid #58606800;
}

.input-group-append {
  border-top-right-radius: 6.4px;
  border-bottom-right-radius: 6.4px;
  background-color: #3d7dd8;
}

.input-group-append button {
  color: white;
  border: 1px solid #58606800;
}

.input-group-append:hover button {
  color: #3d7dd8 !important;
}

.btn-outline-secondary:hover {
  background-color: white;
  color: #3d7dd8 !important;
}

.extxt {
  font-size: 0.75rem;
  font-weight: 500;
  color: rgba(60, 80, 100, 0.8);
}

.checklabel {
  font-size: 0.8125rem;
  font-weight: 500;
}

.styled-checkbox + label:before {
  margin-right: 12px;
  margin-top: -2px;
}

.checkgrouplabel {
  font-size: 1rem;
  font-weight: 500;
}

.checkgrouppanel {
  margin-top: 45px;
}

.unstyled {
  margin-top: 13px;
}

.unstyled li {
  margin-top: 1px;
}

li:after {
  content: "\f107";
  font-family: FontAwesome;
  font-size: 22px;
  position: absolute;
  right: 30px;
  color: #6474847d;
  margin-top: -2px;
}

.companyview-topoptions {
  padding: 10px 15px;
  margin-top: 10px;
}

.companyview-topoptions .col-md-3 {
  padding: 0;
}

.companyview-topoptions .col-md-9 {
  padding: 0;
}

.selectdiv:after {
  content: "\f107";
  color: #6474847d;
  top: 3px;
}

.selectdiv select {
  height: 44px;
}

.rtoptions {
  margin-top: 14px;
  float: left;
  margin-left: 40px;
}

.ceboxes {
  margin: 16px;
  margin-top: 26px;
  margin-bottom: 0px;
  text-align: center;
}

#pointer {
  width: 59.7px;
  height: 24px;
  background: #3d7dd8;
  box-shadow: 0 1px 2px 0 rgba(60, 80, 100, 0.12);

  position: absolute;
  z-index: 1;
  left: 0;
  top: 7px;
}

#pointer:after {
  content: "";
  position: absolute;
  right: -12px;
  bottom: 0;
  width: 0;
  height: 0;
  border-right: 12px solid transparent;
  border-top: 12px solid #3d7dd8;
  border-bottom: 12px solid transparent;
}

#pointer:before {
  content: "";
  position: absolute;
  right: -12px;
  bottom: 0;
  width: 0;
  height: 0;
  border-left: 12px solid #3d7dd8;
  border-top: 12px solid transparent;
}

.newtag {
  font-size: 0.6875rem;
  font-weight: bold;
  color: white;
}

.c_images {
  width: 85%;
  border-radius: 3px;
}

.ctitle {
  font-size: 1.125rem;
  font-weight: 500;
  margin-bottom: 20px;
  margin-top: 10px;
}

.ccontents {
  font-size: 0.625rem;
}

.cline {
  border: solid 0.5px #e6e8ea;
  margin-top: 15px;
  margin-bottom: 15px;
}

.cstitle {
  font-size: 0.8125rem;
  font-weight: 500;
  margin-bottom: 15px;
}

.clickcbtn {
  border-radius: 20px;
  padding: 7px 14px;
  box-shadow: 0 1px 4px 0 rgba(40, 60, 80, 0.4);

  float: right;
  margin-top: 10px;
  margin-bottom: 20px;
}

.cplus {
  font-size: 1.5em;
  line-height: 1;
}

.skillsets {
  text-align: left;
  padding: 9px 10px;
}

@media screen and (max-width: 992px) {
  .rightad {
    padding: 50px 0px;
  }
}

@media screen and (max-width: 768px) {
  .skill-mobile{
      display:none
    }
  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }

  .rightad {
    padding: 0px 10px;
  }

  .leftad {
    padding: 20px 10px;
  }

  .rtoptions {
    margin-top: 14px;
    float: none;
    margin-left: 0px;
  }

  .skillsets {
    padding: 0;
    margin-top: 20px;
  }

  .ceboxes .col-md-3 {
    margin-bottom: 30px;
  }

  .c_images {
    width: 144px;
  }
}
</style>
